import React from "react";
import "./ImportStepBar.scss";

const ImportStepBar = ({ steps, current }) => (
  <div className="import-step-bar">
    <p className="isb-caption">
      Step {current + 1} of {steps.length} <span aria-hidden="true">·</span> <strong>{steps[current]}</strong>
    </p>
    <ol className="isb-track" aria-label="Import steps">
      {steps.map((label, idx) => (
        <li
          key={label}
          className={idx === current ? "is-current" : idx < current ? "is-done" : ""}
          aria-current={idx === current ? "step" : undefined}
        >
          <span className="isb-label">{label}</span>
        </li>
      ))}
    </ol>
  </div>
);

export default ImportStepBar;
